import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = {
    url: String,
  };

  connect() {
    this.initSortable();
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = null;
    }
  }

  initSortable() {
    if (this.sortable) {
      this.sortable.destroy();
    }

    this.sortable = Sortable.create(this.element, {
      animation: 150,
      draggable: "[data-habit-id]",
      handle: ".habit-drag-handle",
      fallbackOnBody: true,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      forceFallback: true,
      swapThreshold: 0.65,
      onEnd: (evt) => {
        this.cleanupStyles();
        this.persistOrder();
      },
    });
  }

  cleanupStyles() {
    this.element.querySelectorAll("[data-habit-id]").forEach((el) => {
      el.style.transform = "";
      el.style.transition = "";
      el.style.position = "";
      el.style.left = "";
      el.style.top = "";
      el.style.zIndex = "";
    });
  }

  async persistOrder() {
    const habitIds = Array.from(this.element.querySelectorAll("[data-habit-id]"))
      .map((el) => el.dataset.habitId)
      .filter(Boolean);

    if (habitIds.length === 0) return;

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken(),
          "Accept": "application/json",
        },
        body: JSON.stringify({ habit_ids: habitIds }),
      });

      if (!response.ok) {
        throw new Error("Reorder failed");
      }

      this.cleanupStyles();
    } catch (error) {
      window.location.reload();
    }
  }

  csrfToken() {
    const token = document.querySelector("meta[name='csrf-token']");
    return token ? token.content : "";
  }
}
